import React, {useContext} from "react";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import "./Greeting.scss";
import landingPerson from "../../assets/lottie/landingPerson";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import {illustration, greeting, yearsOfExperience} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import {useTranslation} from "react-i18next";

export default function Greeting() {
  const {isDark} = useContext(StyleContext);
  const {t} = useTranslation();

  if (!greeting.displayGreeting) {
    return null;
  }

  // ✅ Helper function to send GA event
  const trackButtonClick = label => {
    if (window.gtag) {
      window.gtag("event", "button_click", {
        event_category: "engagement",
        event_label: label
      });
    }
  };

  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {t("greeting.title")}{" "}
                <span className="wave-emoji">{emoji("👋")}</span>
              </h1>

              <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                {emoji(t("greeting.subTitle", {years: yearsOfExperience}))}
              </p>

              <div id="resume" className="empty-div"></div>

              <SocialMedia />

              <div className="button-greeting-div">
                <Button
                  text={t("greeting.contactButton")}
                  href="#contact"
                  onClick={() => trackButtonClick("Contact Me")}
                />
                {greeting.resumeLink && (
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={greeting.resumeLink}
                    download="Resume.pdf"
                    className="download-link-button"
                    onClick={() => trackButtonClick("Download Resume")}
                  >
                    <Button text={t("greeting.resumeButton")} />
                  </a>
                )}
              </div>
            </div>
          </div>

          <div className="greeting-image-div">
            {illustration.animated ? (
              <DisplayLottie animationData={landingPerson} />
            ) : (
              <img
                alt="man sitting on table"
                src={require("../../assets/images/manOnTable.svg")}
              />
            )}
          </div>
        </div>
      </div>
    </Fade>
  );
}
